import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from '../../common/components/filter-base';
import { IAppState } from '../../common/classes/app';
import { IOption } from '../../common/classes/input-option';

enum FilterType {
    Provider, Location, Event, General
}

const FilterEnumMap: { [id: number]: string } = {
    [FilterType.Provider]: 'Providers',
    [FilterType.Location]: 'Locations',
    [FilterType.Event]: 'Events',
    [FilterType.General]: 'Pages'
};


interface IExternalProps {
    property: string;
    title: string;
    description?: string;
    defaultOption?: IOption;
    options?: IOption[];
}

interface StateToProps {
    options?: IOption[];
    selectedOptions?: string;
    matching: { [id: number]: number };
    loading: boolean
}

export class TypeFilter extends FilterBase {

    convertEvtToString(evt: React.MouseEvent<HTMLButtonElement>) {
        return evt.currentTarget.value
    }

    submitChange(evt: React.MouseEvent<HTMLButtonElement>) {

        // this.updateValue(evt)
        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    render() {
        return (
            <ul className="adage-search-facet-list">
                {
                    this.props.options.map((option, index) =>
                        this.props.matching[option.value] > 0 ?
                            <li key={index + option.text}>
                            <button disabled={this.props.loading} className="adage-search-facet-btn" onClick={this.submitChange.bind(this)} value={option.value}>{this.props.matching[option.value]} Matching {this.props.matching[option.value] === 1 ? option.text.slice(0, -1) : option.text}</button>
                            </li>
                            :
                            null
                    )
                }
            </ul>
        )
    }
}

export function sortMapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const options = state.filtersState.filterOptions[ownProps.property];
    let providers = state.listingState.list.filter(it => it.typeOfResult == "ProviderDetailResult");
    let locations = state.listingState.list.filter(it => it.typeOfResult == "LocationDetailResult");
    let events = state.listingState.list.filter(it => it.typeOfResult == "EventDetailResult");
    let care = state.listingState.list.filter(it => it.typeOfResult == "GenericSearchResult");

    let proM = providers[0] ? providers[0].moreItemsOfType : 0;
    let locM = locations[0] ? locations[0].moreItemsOfType : 0;
    let eveM = events[0] ? events[0].moreItemsOfType : 0;
    let carM = care[0] ? care[0].moreItemsOfType : 0;
    const matching = {

        [FilterType.Provider]: proM,
        [FilterType.Location]: locM,
        [FilterType.Event]: eveM,
        [FilterType.General]: carM
    }
    return {
        options: options ? options.map(option => { return { text: FilterEnumMap[option], value: option.toString() } }) : [],
        selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : "",
        matching: matching,
        loading : state.listingState.currentlyRequesting?  true : false
    }
}


export const ConnectedTypeFilter = connect(sortMapStateToProps, mapDispatchToProps)(TypeFilter);